var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_vm.buttonsOnly
        ? _c(
            "w-card",
            { staticClass: "mb" },
            [
              _c(
                "w-card-content",
                [
                  _c("app-permission-toggle", {
                    attrs: {
                      title: _vm.$ct("permission-toggles.is-admin.title"),
                      description: _vm.$ct(
                        "permission-toggles.is-admin.description"
                      ),
                    },
                    model: {
                      value: _vm.value.IsAdmin,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "IsAdmin", $$v)
                      },
                      expression: "value.IsAdmin",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.buttonsOnly
        ? _c(
            "w-card",
            { staticClass: "mb" },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(
                    " " + _vm._s(_vm.$ct("permission-toggles.features")) + " "
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-dropdown",
                    {
                      attrs: {
                        flat: "",
                        sm: "",
                        right: "",
                        items: _vm.extraOptions,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.extraOptionClicked($event)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                    1
                  ),
                ],
                1
              ),
              _c("w-card-content", [
                _c(
                  "div",
                  { staticClass: "toggle-grid" },
                  _vm._l(_vm.featureToggles, function (toggle) {
                    return _c("app-permission-toggle", {
                      key: toggle.key,
                      staticClass: "toggle-cell",
                      attrs: {
                        value: _vm.value[toggle.key],
                        title: _vm.$ct(
                          "permission-toggles." + toggle.i18n + ".title"
                        ),
                        description: _vm.$ct(
                          "permission-toggles." + toggle.i18n + ".description"
                        ),
                        disabled: _vm.value.IsAdmin,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.setFeature(toggle.key, $event)
                        },
                      },
                    })
                  }),
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-card",
        [
          _vm.buttonsOnly
            ? _c("w-card-title", [
                _vm._v(" " + _vm._s(_vm.$ct("hidden-buttons-title")) + " "),
              ])
            : _c(
                "w-card-title",
                { staticClass: "module-access-title" },
                [
                  _c("div", [
                    _c("div", [_vm._v(_vm._s(_vm.$ct("module-access.title")))]),
                    _c("div", { staticClass: "subtitle" }, [
                      _vm._v(_vm._s(_vm.$ct("module-access.subtitle"))),
                    ]),
                  ]),
                  _c("w-spacer"),
                  _c(
                    "div",
                    { staticClass: "set-all" },
                    [
                      _c("span", { staticClass: "set-all-label" }, [
                        _vm._v(_vm._s(_vm.$ct("module-access.set-all"))),
                      ]),
                      _vm._l(_vm.accessLevels, function (lvl) {
                        return _c(
                          "button",
                          {
                            key: lvl,
                            staticClass: "level-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.setAllLevels(lvl)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("module-access.levels." + lvl)) +
                                " "
                            ),
                          ]
                        )
                      }),
                      _c(
                        "w-link",
                        {
                          staticClass: "expand-link",
                          on: {
                            click: function ($event) {
                              _vm.allExpanded = !_vm.allExpanded
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.allExpanded
                                  ? _vm.$ct("module-access.collapse-all")
                                  : _vm.$ct("module-access.expand-all")
                              ) +
                              " "
                          ),
                          _c("w-fa", {
                            attrs: {
                              icon: _vm.allExpanded
                                ? "chevron-up"
                                : "chevron-down",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.ClientPermissions,
              name: _vm.$ct("client-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.SupplierPermissions,
              name: _vm.$ct("suppliers-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.ProspectPermissions,
              name: _vm.$ct("prospect-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.ProductPermissions,
              name: _vm.$ct("product-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.StockPermissions,
              name: _vm.$ct("stock-browse"),
            },
          }),
          _c(
            "app-browse-row",
            {
              attrs: {
                "buttons-only": _vm.buttonsOnly,
                "expand-all": _vm.allExpanded,
                permissions: _vm.value.SalePermissions,
                name: _vm.$ct("sale-browse"),
              },
            },
            [
              !_vm.buttonsOnly
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-multi-select", {
                            attrs: {
                              label: _vm.$ct("can-create-sales"),
                              items: _vm.saleTypeItems,
                              fancy: "",
                            },
                            model: {
                              value: _vm.managableSaleDocTypes,
                              callback: function ($$v) {
                                _vm.managableSaleDocTypes = $$v
                              },
                              expression: "managableSaleDocTypes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.SaleRowPermissions,
              name: _vm.$ct("sale-row"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.SubscriptionPermissions,
              name: _vm.$ct("subscription-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.ProspectDocumentPermissions,
              name: _vm.$ct("prospect-document-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.BankPermissions,
              name: _vm.$ct("bank-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.BookKeepingPermissions,
              name: _vm.$ct("bookkeeping"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.PurchasePermissions,
              name: _vm.$ct("purchase-browse"),
            },
          }),
          _c(
            "app-browse-row",
            {
              attrs: {
                "buttons-only": _vm.buttonsOnly,
                "expand-all": _vm.allExpanded,
                permissions: _vm.value.PurchaseDocumentPermissions,
                name: _vm.$ct("purchase-document-browse"),
              },
            },
            [
              !_vm.buttonsOnly
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-multi-select", {
                            attrs: {
                              label: _vm.$ct("can-create-purchases"),
                              items: _vm.purchaseTypeItems,
                              fancy: "",
                            },
                            model: {
                              value: _vm.managablePurchaseDocTypes,
                              callback: function ($$v) {
                                _vm.managablePurchaseDocTypes = $$v
                              },
                              expression: "managablePurchaseDocTypes",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.PurchaseDocumentRowsPermissions,
              name: _vm.$ct("purchase-document-row-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.CrmPermissions,
              name: _vm.$ct("crm-browse"),
            },
          }),
          _c("app-browse-row", {
            attrs: {
              "buttons-only": _vm.buttonsOnly,
              "expand-all": _vm.allExpanded,
              permissions: _vm.value.CarPermissions,
              name: _vm.$ct("car-browse"),
            },
          }),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.copySettingsModal,
                callback: function ($$v) {
                  _vm.copySettingsModal = $$v
                },
                expression: "copySettingsModal",
              },
            },
            [
              _c(
                "w-card",
                { attrs: { "max-width": 500 } },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$ct("copy-settings-title")) + " "
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              return _vm.closeCopySettings()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list",
                    _vm._l(_vm.allUsers, function (thisUser) {
                      return _c(
                        "w-list-item",
                        {
                          key: thisUser.ID,
                          on: {
                            click: function ($event) {
                              return _vm.copySettingsFromUser(thisUser.ID)
                            },
                          },
                        },
                        [
                          _c("w-list-item-text", [
                            _vm._v(_vm._s(thisUser.getUserString())),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }